import {Webp} from "./webp";
import {TypeUtils} from "../../../../shared/utils/type-utils";

export class WebpMapper {
  public static map(data: any) {
    const webp: Webp = new Webp();
    webp.webpStatus = !!data.webp_delivery;
    webp.hosting = data.hosting;
    webp.htaccessWritable = !!data.htaccess_writable;
    webp.webpDeliveryWorking = data.webp_delivery_working;
    webp.autoOptimize = TypeUtils.isDefined(data.enable_auto_optimization) && !!data.enable_auto_optimization;
    webp.pictureWebpStatus = !!data.picture_webp_delivery;
    return webp;
  }
}
